import React from "react";
export default class Header extends React.Component {
  handleLogout = () => {
    localStorage.removeItem("id_token");
    localStorage.removeItem("access_token");
    window.location.href = "http://cms-campaign.narendramodi.in";
  };
  render() {
    return (
      <nav
        className="navbar navbar-static-top  "
        role="navigation"
        style={{ marginBottom: "0" }}
      >
        <div className="navbar-header">
          <a
            className="navbar-minimalize minimalize-styl-2 btn btn-primary "
            href="#"
          >
            <i className="fa fa-bars"></i>{" "}
          </a>
          <form
            role="search"
            className="navbar-form-custom"
            action="search_results.html"
          >
            <div className="form-group">
              <input
                type="text"
                placeholder="Search for something..."
                className="form-control"
                name="top-search"
                id="top-search"
              />
            </div>
          </form>
        </div>
        <ul className="nav navbar-top-links navbar-right">
          <li>
            <span className="m-r-sm text-muted welcome-message">
              Welcome to Narendra Modi Campaigns CMS.
            </span>
          </li>

          <li>
            <a href="javascript:void(0)" onClick={this.handleLogout}>
              <i className="fa fa-sign-out"></i> Log out
            </a>
          </li>
        </ul>
      </nav>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Header.jsx